<template>
  <div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  methods: {
    ...mapActions({
        logoutAction: 'user/logout'
    }),
  },
  mounted(){
    this.logoutAction().then(()=>{
      this.$router.push('/login')
    })
  }
}
</script>